"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.file_valley_bank_sls_ingest = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const dbNodes = __importStar(require("../../../dbNodes/dbNodes"));
const commonTapeNode_1 = require("../../commonTapeNode");
const utils = __importStar(require("../../utils"));
const utils_1 = require("../../utils");
const uinode_1 = require("../intermediate-tape/uinode");
const uinode_2 = require("../raw-supplemental-tape/uinode");
const types_1 = require("./types");
const { isNode, isIntermediateRecord, ...otherProps } = (0, commonTapeNode_1.commonTapeNodeUtils)(types_1.nodeType, types_1.artifactType, types_1.UIConfigSchema);
// create a new UI node of this type.
const createNewNode = ({ id, suggestedSerialNumber, nodeToCopy, }) => {
    const friendlyName = `Valley SLS Ingest`;
    const nodeData = {
        metadata: {
            tapeBuilderNodeId: id,
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: {
            artifactSlug: `${_.camelCase(friendlyName)}_${suggestedSerialNumber}`,
            noteRawTapeArtifactSlug: '[ POINT TO RAW NOTE TAPE ]',
            participantRawTapeArtifactSlug: '[ POINT TO RAW PARTICIPANT TAPE ]',
            noteTransactionArtifactSlug: '[ POINT TO NOTE OUTPUT ]',
            participantTransactionArtifactSlug: '[ POINT TO PARTICIPANT OUTPUT ]',
        },
    };
    if (nodeToCopy) {
        nodeData.configuration = (0, utils_1.copyNodeConfiguration)({
            nodeToCopy,
            isNode,
            nodeType: types_1.nodeType,
            suggestedSerialNumber,
        });
    }
    return nodeData;
};
/**
 * validate the configuration for the node. This checks shape as well
 * logical correctness.
 * This function should validate the config wrt rest of the graph as well.
 * if there is an error it should return an array of error messages.
 * if there are no errors it should return an empty array.
 */
const hasValidConfig = ({ node, friendlyName, inputs, outputs, graph, }) => {
    (0, common_1.finleyAssert)(isNode(node), `node must be a ${types_1.nodeType} node`);
    const configErrors = [];
    const edgeErrors = (0, utils_1.checkEdges)({
        friendlyName,
        inputs,
        outputs,
        isAllowedInputNode: (uiNode) => uiNode.nodeType === 'file_intermediateTape',
        minInputs: 1,
        maxInputs: 100,
        minOutputs: 0,
        maxOutputs: 0,
    });
    edgeErrors.forEach((error) => configErrors.push(error));
    const { artifactSlug, noteRawTapeArtifactSlug, participantRawTapeArtifactSlug, noteTransactionArtifactSlug, participantTransactionArtifactSlug, } = node.configuration;
    const directInputNodes = inputs.map(({ node: inputNode }) => inputNode);
    const intermediateInputs = directInputNodes.filter(uinode_1.file_intermediateTape.isNode);
    const allInputs = utils.getAllInputDependencyNodesForNode(node, graph);
    const rawSupplementInput = allInputs.filter(uinode_2.file_rawSupplementalTape.isNode);
    // Check that the referenced artifact slugs are valid input nodes.
    // *** Raw Supplemental Tapes ***
    const foundNoteRawInput = rawSupplementInput.some((x) => x.configuration.artifactSlug === noteRawTapeArtifactSlug);
    if (!foundNoteRawInput) {
        configErrors.push(`[artifact:${artifactSlug}] did not find valid raw supplemental tape input for note transactions [noteRawTapeArtifactSlug:${noteRawTapeArtifactSlug}]`);
    }
    const foundParticipantRawInput = rawSupplementInput.some((x) => x.configuration.artifactSlug === participantRawTapeArtifactSlug);
    if (!foundParticipantRawInput) {
        configErrors.push(`[artifact:${artifactSlug}] did not find valid raw supplemental tape input for participant transactions [participantRawTapeArtifactSlug:${participantRawTapeArtifactSlug}]`);
    }
    // *** Note Transaction Tape ***
    const foundNoteInput = intermediateInputs.some((x) => x.configuration.artifactSlug === noteTransactionArtifactSlug);
    if (!foundNoteInput) {
        configErrors.push(`[artifact:${artifactSlug}] did not find valid Note Transaction input [noteTransactionArtifactSlug:${noteTransactionArtifactSlug}]`);
    }
    // *** Participant Transaction Tape ***
    const foundParticipantInput = intermediateInputs.some((x) => x.configuration.artifactSlug === participantTransactionArtifactSlug);
    if (!foundParticipantInput) {
        configErrors.push(`[artifact:${artifactSlug}] did not find valid Participant Transaction input [participantTransactionArtifactSlug:${participantTransactionArtifactSlug}]`);
    }
    return configErrors;
};
const validateIntermediateTape = (input) => {
    const { tape, tapeBuilder, graph } = input;
    const { id, artifactSlug, configuration } = tape;
    (0, common_1.finleyAssert)(isIntermediateRecord(tape), `validateIntermediateTape: tape is not an ${types_1.artifactType}`);
    (0, common_1.finleyAssert)(dbNodes.valleyBankSlsIngest.isNodeConfig(configuration), `validateIntermediateTape: Valley Bank SLS Ingest tape configuration is not expected structure [artifactSlug:${artifactSlug}]`);
    const configErrors = [];
    const sourceArtifacts = utils.getDirectInputsForArtifact({
        ...graph,
        targetArtifactId: id,
    });
    if (sourceArtifacts.length < 2) {
        // 2 for at least "Note" and "Participant" transaction tapes,
        // can be more there with optional "Commitment" tape too
        configErrors.push(`Expected at least 2 input nodes for Valley Bank SLS Ingest, received ${sourceArtifacts.length}`);
        // Return early since no need to even try fetching the tape definition
        // and checking it without having the expected target input node
        return configErrors;
    }
    // *** Note Transaction Input Validation ***
    const noteTransactionInput = sourceArtifacts.find((x) => x.artifactSlug === configuration.noteTransactionArtifactSlug);
    if (!noteTransactionInput) {
        configErrors.push(`valley-bank-sls-ingest: [${artifactSlug}] did not find valid input [noteTransactionArtifactSlug:${configuration.noteTransactionArtifactSlug}]`);
        return configErrors;
    }
    const noteTapeDefinitionResult = tapeBuilder.generateTapeDefinition(noteTransactionInput.id);
    (0, common_1.finleyAssert)(noteTapeDefinitionResult.isValid, `valley-bank-sls-ingest note input tapeDefinition for ${artifactSlug} is not valid`);
    (0, common_1.finleyAssert)(noteTapeDefinitionResult.data, `valley-bank-sls-ingest note input tapeDefinition for ${artifactSlug} is null`);
    const noteBaseFields = noteTapeDefinitionResult.data.baseFields;
    finley_types_1.IbsIntegration.NOTE_TRANSACTION_CSV_FIELDS.forEach((requiredField) => {
        const { field, type } = requiredField;
        const baseField = noteBaseFields.find((x) => x.field === field);
        if (!baseField) {
            configErrors.push(`valley-bank-sls-ingest: [${artifactSlug}] is expected to have [${field}] for note transaction input`);
        }
        else if (baseField.type !== type) {
            configErrors.push(`valley-bank-sls-ingest: [${artifactSlug}] has [${field}] of type [${baseField.type}] but expected [${type}] for note transaction input`);
        }
    });
    // *** Participant Transaction Input Validation ***
    const participantTransactionInput = sourceArtifacts.find((x) => x.artifactSlug === configuration.participantTransactionArtifactSlug);
    if (!participantTransactionInput) {
        configErrors.push(`valley-bank-sls-ingest: [${artifactSlug}] did not find valid input [participantTransactionArtifactSlug:${configuration.participantTransactionArtifactSlug}]`);
        return configErrors;
    }
    const participantTapeDefinitionResult = tapeBuilder.generateTapeDefinition(participantTransactionInput.id);
    (0, common_1.finleyAssert)(participantTapeDefinitionResult.isValid, `valley-bank-sls-ingest participant input tapeDefinition for ${artifactSlug} is not valid`);
    (0, common_1.finleyAssert)(participantTapeDefinitionResult.data, `valley-bank-sls-ingest participant input tapeDefinition for ${artifactSlug} is null`);
    const participantBaseFields = participantTapeDefinitionResult.data.baseFields;
    finley_types_1.IbsIntegration.PARTICIPANT_TRANSACTION_CSV_FIELDS.forEach((requiredField) => {
        const { field, type } = requiredField;
        const baseField = participantBaseFields.find((x) => x.field === field);
        if (!baseField) {
            configErrors.push(`valley-bank-sls-ingest: [${artifactSlug}] is expected to have [${field}] for participant transaction input`);
        }
        else if (baseField.type !== type) {
            configErrors.push(`valley-bank-sls-ingest: [${artifactSlug}] has [${field}] of type [${baseField.type}] but expected [${type}] for participant transaction input`);
        }
    });
    return configErrors;
};
/**
 * Represents a UI node with various properties and methods.
 */
exports.file_valley_bank_sls_ingest = {
    nodeTypeText: 'ValleySlsIngest',
    nodeType: types_1.nodeType,
    artifactType: types_1.artifactType,
    isOperation: false,
    isRaw: false,
    isFinal: true,
    badgeTexts: ['ValleySlsIngest'],
    createNewNode,
    isNode,
    isIntermediateRecord,
    ...otherProps,
    hasValidConfig,
    validateIntermediateTape,
};
//# sourceMappingURL=uinode.js.map